export default __webpack_public_path__ + "static/media/gallery-wip-emitter_18.183b1a92.jpg";